<template>
  <Transition name="dialog">
    <div
      v-if="show"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-6"
      @click.self="handleCancel"
    >
      <div class="bg-white rounded-2xl p-6 max-w-sm w-full max-h-[calc(100dvh-3rem)] overflow-y-auto shadow-2xl animate-in fade-in zoom-in-95 duration-200" @click.stop>
        <!-- 標題 -->
        <h3 class="text-lg font-bold text-textMain mb-3">{{ title }}</h3>

        <!-- 內容 -->
        <p class="text-sm text-textMuted leading-relaxed mb-6 whitespace-pre-line">{{ message }}</p>

        <slot />

        <!-- 按鈕 -->
        <div class="flex gap-3">
          <button
            @click="handleCancel"
            class="flex-1 py-3 rounded-xl font-bold text-textMuted bg-gray-100 active:scale-95 transition-all"
            :disabled="loading"
          >
            {{ cancelText }}
          </button>
          <button
            @click="handleConfirm"
            class="flex-1 py-3 rounded-xl font-bold active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            :class="warm ? 'bg-primary/60 text-[#714F45]' : danger ? 'bg-red-500 text-white' : 'bg-primary text-white'"
            :disabled="loading"
          >
            {{ loading ? loadingText : confirmText }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
interface Props {
  show: boolean
  title: string
  message: string
  danger?: boolean
  warm?: boolean
  loading?: boolean
  confirmText?: string
  cancelText?: string
  loadingText?: string
}

const props = withDefaults(defineProps<Props>(), {
  confirmText: '確定',
  cancelText: '取消',
  loadingText: '處理中...'
})

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}
</script>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoom-in-95 {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

.animate-in {
  animation: fade-in 0.2s ease, zoom-in-95 0.2s ease;
}
</style>
